export const cloudFuncLink =
  "https://us-central1-nduduzo-portfolio.cloudfunctions.net/sendMail";
